import * as formWizardConstants from './constants';

/**
 * Gets the back button on a panel
 *
 * @param {Element} panel
 */
export default function getBackButton(panel) {
  if (!panel) return;
  return panel.querySelector(formWizardConstants.selectors.backButton);
}
